/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActionBaseResponse as ApiActionBaseResponse } from '../models/api/action-base-response';
import { ActionResponse as ApiActionResponse } from '../models/api/action-response';
import { CostResponse as ApiCostResponse } from '../models/api/cost-response';
import { ImageResponse as ApiImageResponse } from '../models/api/image-response';
import { InterventionLibraryResponse as ApiInterventionLibraryResponse } from '../models/api/intervention-library-response';
import { LinkingTextResponse as ApiLinkingTextResponse } from '../models/api/linking-text-response';
import { ListActionsResponse as ApiListActionsResponse } from '../models/api/list-actions-response';
import { ListImagesResponse as ApiListImagesResponse } from '../models/api/list-images-response';
import { ListInterventionLibrariesResponse as ApiListInterventionLibrariesResponse } from '../models/api/list-intervention-libraries-response';
import { ListLinkingTextsResponse as ApiListLinkingTextsResponse } from '../models/api/list-linking-texts-response';
import { createAction } from '../fn/actions/create-action';
import { CreateAction$Params } from '../fn/actions/create-action';
import { createCostForAction } from '../fn/actions/create-cost-for-action';
import { CreateCostForAction$Params } from '../fn/actions/create-cost-for-action';
import { createImage } from '../fn/actions/create-image';
import { CreateImage$Params } from '../fn/actions/create-image';
import { createLinkingText } from '../fn/actions/create-linking-text';
import { CreateLinkingText$Params } from '../fn/actions/create-linking-text';
import { deleteAction } from '../fn/actions/delete-action';
import { DeleteAction$Params } from '../fn/actions/delete-action';
import { deleteCostByActionId } from '../fn/actions/delete-cost-by-action-id';
import { DeleteCostByActionId$Params } from '../fn/actions/delete-cost-by-action-id';
import { deleteImage } from '../fn/actions/delete-image';
import { DeleteImage$Params } from '../fn/actions/delete-image';
import { deleteLinkingText } from '../fn/actions/delete-linking-text';
import { DeleteLinkingText$Params } from '../fn/actions/delete-linking-text';
import { extensiveListActions } from '../fn/actions/extensive-list-actions';
import { ExtensiveListActions$Params } from '../fn/actions/extensive-list-actions';
import { getAction } from '../fn/actions/get-action';
import { GetAction$Params } from '../fn/actions/get-action';
import { getCost } from '../fn/actions/get-cost';
import { GetCost$Params } from '../fn/actions/get-cost';
import { getImage } from '../fn/actions/get-image';
import { GetImage$Params } from '../fn/actions/get-image';
import { getInterventionLibrary } from '../fn/actions/get-intervention-library';
import { GetInterventionLibrary$Params } from '../fn/actions/get-intervention-library';
import { getLinkingText } from '../fn/actions/get-linking-text';
import { GetLinkingText$Params } from '../fn/actions/get-linking-text';
import { listActions } from '../fn/actions/list-actions';
import { ListActions$Params } from '../fn/actions/list-actions';
import { listImages } from '../fn/actions/list-images';
import { ListImages$Params } from '../fn/actions/list-images';
import { listInterventionLibraries } from '../fn/actions/list-intervention-libraries';
import { ListInterventionLibraries$Params } from '../fn/actions/list-intervention-libraries';
import { listLinkingTexts } from '../fn/actions/list-linking-texts';
import { ListLinkingTexts$Params } from '../fn/actions/list-linking-texts';
import { shareAction } from '../fn/actions/share-action';
import { ShareAction$Params } from '../fn/actions/share-action';
import { updateAction } from '../fn/actions/update-action';
import { UpdateAction$Params } from '../fn/actions/update-action';
import { updateCostForAction } from '../fn/actions/update-cost-for-action';
import { UpdateCostForAction$Params } from '../fn/actions/update-cost-for-action';
import { updateImage } from '../fn/actions/update-image';
import { UpdateImage$Params } from '../fn/actions/update-image';
import { updateLinkingText } from '../fn/actions/update-linking-text';
import { UpdateLinkingText$Params } from '../fn/actions/update-linking-text';

@Injectable({ providedIn: 'root' })
export class ActionsService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listActions()` */
  static readonly ListActionsPath = '/v1/boards/{boardId}/actions';

  /**
   * List Actions.
   *
   * List Actions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActions$Response(
    params: ListActions$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionsResponse>> {
    return listActions(this.http, this.rootUrl, params, context);
  }

  /**
   * List Actions.
   *
   * List Actions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActions(params: ListActions$Params, context?: HttpContext): Observable<ApiListActionsResponse> {
    return this.listActions$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionsResponse>): ApiListActionsResponse => r.body)
    );
  }

  /** Path part for operation `createAction()` */
  static readonly CreateActionPath = '/v1/boards/{boardId}/actions';

  /**
   * Create Action.
   *
   * Create an Action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAction$Response(
    params: CreateAction$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionBaseResponse>> {
    return createAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Action.
   *
   * Create an Action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAction(params: CreateAction$Params, context?: HttpContext): Observable<ApiActionBaseResponse> {
    return this.createAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionBaseResponse>): ApiActionBaseResponse => r.body)
    );
  }

  /** Path part for operation `extensiveListActions()` */
  static readonly ExtensiveListActionsPath = '/v1/boards/{boardId}/actions/extensive';

  /**
   * Extensively List Actions.
   *
   * Extensively List Actions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `extensiveListActions()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  extensiveListActions$Response(
    params: ExtensiveListActions$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionsResponse>> {
    return extensiveListActions(this.http, this.rootUrl, params, context);
  }

  /**
   * Extensively List Actions.
   *
   * Extensively List Actions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `extensiveListActions$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  extensiveListActions(params: ExtensiveListActions$Params, context?: HttpContext): Observable<ApiListActionsResponse> {
    return this.extensiveListActions$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionsResponse>): ApiListActionsResponse => r.body)
    );
  }

  /** Path part for operation `listInterventionLibraries()` */
  static readonly ListInterventionLibrariesPath = '/v1/boards/{boardId}/actions/libraries';

  /**
   * List Intervention Libraries.
   *
   * List intervention libraries
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInterventionLibraries()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInterventionLibraries$Response(
    params: ListInterventionLibraries$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListInterventionLibrariesResponse>> {
    return listInterventionLibraries(this.http, this.rootUrl, params, context);
  }

  /**
   * List Intervention Libraries.
   *
   * List intervention libraries
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInterventionLibraries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInterventionLibraries(
    params: ListInterventionLibraries$Params,
    context?: HttpContext
  ): Observable<ApiListInterventionLibrariesResponse> {
    return this.listInterventionLibraries$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListInterventionLibrariesResponse>): ApiListInterventionLibrariesResponse => r.body)
    );
  }

  /** Path part for operation `getInterventionLibrary()` */
  static readonly GetInterventionLibraryPath = '/v1/boards/{boardId}/actions/libraries/{id}';

  /**
   * Get Intervention Library.
   *
   * Get an intervention library
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInterventionLibrary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterventionLibrary$Response(
    params: GetInterventionLibrary$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiInterventionLibraryResponse>> {
    return getInterventionLibrary(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Intervention Library.
   *
   * Get an intervention library
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInterventionLibrary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInterventionLibrary(
    params: GetInterventionLibrary$Params,
    context?: HttpContext
  ): Observable<ApiInterventionLibraryResponse> {
    return this.getInterventionLibrary$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiInterventionLibraryResponse>): ApiInterventionLibraryResponse => r.body)
    );
  }

  /** Path part for operation `getCost()` */
  static readonly GetCostPath = '/v1/boards/{boardId}/actions/{actionId}/cost';

  /**
   * Get cost by ActionId.
   *
   * Get a cost by ActionId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCost$Response(params: GetCost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiCostResponse>> {
    return getCost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get cost by ActionId.
   *
   * Get a cost by ActionId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCost(params: GetCost$Params, context?: HttpContext): Observable<ApiCostResponse> {
    return this.getCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiCostResponse>): ApiCostResponse => r.body)
    );
  }

  /** Path part for operation `createCostForAction()` */
  static readonly CreateCostForActionPath = '/v1/boards/{boardId}/actions/{actionId}/cost';

  /**
   * Create Cost for an Action.
   *
   * Create a Cost for an Action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCostForAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCostForAction$Response(
    params: CreateCostForAction$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiCostResponse>> {
    return createCostForAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Cost for an Action.
   *
   * Create a Cost for an Action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCostForAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCostForAction(params: CreateCostForAction$Params, context?: HttpContext): Observable<ApiCostResponse> {
    return this.createCostForAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiCostResponse>): ApiCostResponse => r.body)
    );
  }

  /** Path part for operation `deleteCostByActionId()` */
  static readonly DeleteCostByActionIdPath = '/v1/boards/{boardId}/actions/{actionId}/cost';

  /**
   * Delete Cost.
   *
   * Delete a Cost by ActionId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCostByActionId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCostByActionId$Response(
    params: DeleteCostByActionId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteCostByActionId(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Cost.
   *
   * Delete a Cost by ActionId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCostByActionId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCostByActionId(params: DeleteCostByActionId$Params, context?: HttpContext): Observable<string> {
    return this.deleteCostByActionId$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateCostForAction()` */
  static readonly UpdateCostForActionPath = '/v1/boards/{boardId}/actions/{actionId}/cost';

  /**
   * Update Cost for an Action.
   *
   * Update a Cost for an Action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCostForAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCostForAction$Response(
    params: UpdateCostForAction$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateCostForAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Cost for an Action.
   *
   * Update a Cost for an Action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCostForAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCostForAction(params: UpdateCostForAction$Params, context?: HttpContext): Observable<string> {
    return this.updateCostForAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listImages()` */
  static readonly ListImagesPath = '/v1/boards/{boardId}/actions/{actionId}/images';

  /**
   * List Images.
   *
   * List Images
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImages()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImages$Response(
    params: ListImages$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListImagesResponse>> {
    return listImages(this.http, this.rootUrl, params, context);
  }

  /**
   * List Images.
   *
   * List Images
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImages(params: ListImages$Params, context?: HttpContext): Observable<ApiListImagesResponse> {
    return this.listImages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListImagesResponse>): ApiListImagesResponse => r.body)
    );
  }

  /** Path part for operation `createImage()` */
  static readonly CreateImagePath = '/v1/boards/{boardId}/actions/{actionId}/images';

  /**
   * Create Image.
   *
   * Create Image
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createImage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createImage$Response(
    params: CreateImage$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiImageResponse>> {
    return createImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Image.
   *
   * Create Image
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createImage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createImage(params: CreateImage$Params, context?: HttpContext): Observable<ApiImageResponse> {
    return this.createImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiImageResponse>): ApiImageResponse => r.body)
    );
  }

  /** Path part for operation `getImage()` */
  static readonly GetImagePath = '/v1/boards/{boardId}/actions/{actionId}/images/{id}';

  /**
   * Get Image.
   *
   * Get Image
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage$Response(params: GetImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiImageResponse>> {
    return getImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Image.
   *
   * Get Image
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage(params: GetImage$Params, context?: HttpContext): Observable<ApiImageResponse> {
    return this.getImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiImageResponse>): ApiImageResponse => r.body)
    );
  }

  /** Path part for operation `deleteImage()` */
  static readonly DeleteImagePath = '/v1/boards/{boardId}/actions/{actionId}/images/{id}';

  /**
   * Delete Image.
   *
   * delete Image
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage$Response(params: DeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return deleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Image.
   *
   * delete Image
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage(params: DeleteImage$Params, context?: HttpContext): Observable<string> {
    return this.deleteImage$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `updateImage()` */
  static readonly UpdateImagePath = '/v1/boards/{boardId}/actions/{actionId}/images/{id}';

  /**
   * Update Image.
   *
   * Update Image
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImage$Response(
    params: UpdateImage$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiImageResponse>> {
    return updateImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Image.
   *
   * Update Image
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateImage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImage(params: UpdateImage$Params, context?: HttpContext): Observable<ApiImageResponse> {
    return this.updateImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiImageResponse>): ApiImageResponse => r.body)
    );
  }

  /** Path part for operation `listLinkingTexts()` */
  static readonly ListLinkingTextsPath = '/v1/boards/{boardId}/actions/{actionId}/linking-texts';

  /**
   * List LinkingTexts.
   *
   * List linkingTexts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listLinkingTexts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLinkingTexts$Response(
    params: ListLinkingTexts$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListLinkingTextsResponse>> {
    return listLinkingTexts(this.http, this.rootUrl, params, context);
  }

  /**
   * List LinkingTexts.
   *
   * List linkingTexts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listLinkingTexts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLinkingTexts(params: ListLinkingTexts$Params, context?: HttpContext): Observable<ApiListLinkingTextsResponse> {
    return this.listLinkingTexts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListLinkingTextsResponse>): ApiListLinkingTextsResponse => r.body)
    );
  }

  /** Path part for operation `createLinkingText()` */
  static readonly CreateLinkingTextPath = '/v1/boards/{boardId}/actions/{actionId}/linking-texts';

  /**
   * Create LinkingText.
   *
   * Create a linkingText
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLinkingText()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLinkingText$Response(
    params: CreateLinkingText$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiLinkingTextResponse>> {
    return createLinkingText(this.http, this.rootUrl, params, context);
  }

  /**
   * Create LinkingText.
   *
   * Create a linkingText
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLinkingText$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLinkingText(params: CreateLinkingText$Params, context?: HttpContext): Observable<ApiLinkingTextResponse> {
    return this.createLinkingText$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiLinkingTextResponse>): ApiLinkingTextResponse => r.body)
    );
  }

  /** Path part for operation `getLinkingText()` */
  static readonly GetLinkingTextPath = '/v1/boards/{boardId}/actions/{actionId}/linking-texts/{id}';

  /**
   * Get LinkingText.
   *
   * Get a specific linkingText
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLinkingText()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinkingText$Response(
    params: GetLinkingText$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiLinkingTextResponse>> {
    return getLinkingText(this.http, this.rootUrl, params, context);
  }

  /**
   * Get LinkingText.
   *
   * Get a specific linkingText
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLinkingText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinkingText(params: GetLinkingText$Params, context?: HttpContext): Observable<ApiLinkingTextResponse> {
    return this.getLinkingText$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiLinkingTextResponse>): ApiLinkingTextResponse => r.body)
    );
  }

  /** Path part for operation `deleteLinkingText()` */
  static readonly DeleteLinkingTextPath = '/v1/boards/{boardId}/actions/{actionId}/linking-texts/{id}';

  /**
   * Delete LinkingText.
   *
   * Delete a linkingText
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLinkingText()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLinkingText$Response(
    params: DeleteLinkingText$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteLinkingText(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete LinkingText.
   *
   * Delete a linkingText
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLinkingText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLinkingText(params: DeleteLinkingText$Params, context?: HttpContext): Observable<string> {
    return this.deleteLinkingText$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateLinkingText()` */
  static readonly UpdateLinkingTextPath = '/v1/boards/{boardId}/actions/{actionId}/linking-texts/{id}';

  /**
   * Update LinkingText.
   *
   * Update a linkingText
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLinkingText()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLinkingText$Response(
    params: UpdateLinkingText$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateLinkingText(this.http, this.rootUrl, params, context);
  }

  /**
   * Update LinkingText.
   *
   * Update a linkingText
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLinkingText$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLinkingText(params: UpdateLinkingText$Params, context?: HttpContext): Observable<string> {
    return this.updateLinkingText$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getAction()` */
  static readonly GetActionPath = '/v1/boards/{boardId}/actions/{id}';

  /**
   * Get Action.
   *
   * Get an action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAction$Response(
    params: GetAction$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionResponse>> {
    return getAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Action.
   *
   * Get an action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAction(params: GetAction$Params, context?: HttpContext): Observable<ApiActionResponse> {
    return this.getAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionResponse>): ApiActionResponse => r.body)
    );
  }

  /** Path part for operation `deleteAction()` */
  static readonly DeleteActionPath = '/v1/boards/{boardId}/actions/{id}';

  /**
   * Delete Action.
   *
   * Delete an action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAction()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAction$Response(params: DeleteAction$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return deleteAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Action.
   *
   * Delete an action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAction(params: DeleteAction$Params, context?: HttpContext): Observable<string> {
    return this.deleteAction$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `updateAction()` */
  static readonly UpdateActionPath = '/v1/boards/{boardId}/actions/{id}';

  /**
   * Update Action.
   *
   * Update an action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAction$Response(params: UpdateAction$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return updateAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Action.
   *
   * Update an action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAction(params: UpdateAction$Params, context?: HttpContext): Observable<string> {
    return this.updateAction$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `shareAction()` */
  static readonly ShareActionPath = '/v1/boards/{boardId}/actions/{id}/share';

  /**
   * Share Action.
   *
   * Share an action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shareAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shareAction$Response(params: ShareAction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return shareAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Share Action.
   *
   * Share an action
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shareAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shareAction(params: ShareAction$Params, context?: HttpContext): Observable<void> {
    return this.shareAction$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
